import { createFileRoute } from '@tanstack/react-router'
import { groupReceiptSearchSchema, GroupReceiptWorkspace } from '@/features/bill/index.ts'

export const Route = createFileRoute('/_authenticated/finance/groups_/receipt-batch')({
  validateSearch: groupReceiptSearchSchema,
  component: BatchReceiptPage,
  head: () => ({ meta: [{ title: '批量登记收款 · Super Mega' }] })
})

function BatchReceiptPage() {
  const { target } = Route.useSearch()
  return <GroupReceiptWorkspace key={JSON.stringify(target)} target={target} />
}
